import React from 'react';
import webHosting from "../../assets/img/dadicate-web-hosting.svg";
import vpsHosting from "../../assets/img/vps-hosting.svg";
import cloudHosting from "../../assets/img/cloud-hosting.svg";
import { PriceCardData, UpdatePlanTexts } from '../Data/Pages';
import PricingTableCard from '../PricingTableCard';


const PricingSection = () => {

    const planRanks = { basic: 1, standard: 2, premium: 3 };


    return (
        <section className="pricing-section ptb-100 gray-light-bg">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-9 col-lg-6">
                        <div className="section-heading text-center mb-4">
                            <h2>Our Flexible Pricing Plan</h2>
                            <p>
                                Professional hosting at an affordable price. Distinctively
                                recaptiualize principle-centered core competencies through
                                client-centered core competencies.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="row align-items-center justify-content-md-center justify-content-center">

                    {PriceCardData?.map((data, i) => (
                        <PricingTableCard
                            key={i}
                            image={data.image}
                            planType={data.head}
                            list={data.list}
                            price={data.price}
                            planRanks={planRanks}

                        />
                    ))}
                    <div className="col-12">
                        <div className="support-cta text-center mt-5">
                            <h5 className="mb-1">
                                <span className="fas fa-headset color-primary me-3"></span>We're Here to Help You
                            </h5>
                            <p>
                                Have some questions? <a href="contact-us.html">Chat with us now</a>, or
                                <a href="contact-us.html">send us an email</a> to get in touch.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PricingSection;
